module.exports = __webpack_public_path__ + "img/ar_small_pri.dd6dae83.svg";